import { Navigate } from 'react-router-dom';
import { ReactElement } from 'react';
import { isAdminUser } from '../auth/cognito';

export default function ProtectedRoute({ children }: { children: ReactElement }) {
  if (!isAdminUser()) return <Navigate to="/login" replace />;
  return children;
}
